import * as types from "./types";
import JigsawAPI from "../../services/jigsaw";
import * as selectors from "./selectors";
import { selectors as brandSelectors } from "../brand";
import { actions as bridgeActions } from "../bridge";

export const updateLicenseBegin = () => ({
  type: types.UPDATE_LICENSE_REQUEST
});

export const licenseUpdated = () => ({ type: types.UPDATE_LICENSE_SUCCESS });

export const licenseUpdateFailed = error => ({
  type: types.UPDATE_LICENSE_FAILURE,
  error
});

const asyncUpdateLicense = dispatch => {
  const checkLicenseStatus = id => {
    JigsawAPI.User.asyncLicenseStatus(id).then(({ id, message }) => {
      if (message === "finished" || !message) {
        dispatch(licenseUpdated());
      } else {
        setTimeout(() => {
          checkLicenseStatus(id);
        }, 3000);
      }
    });
  };
  return JigsawAPI.User.asyncUpdateLicense()
    .then(({ id }) => {
      checkLicenseStatus(id); // I *think* that's the attr
    })
    .catch(error => dispatch(licenseUpdateFailed(error)));
};

export const updateLicense = () => async (dispatch, getState) => {
  const state = getState();
  if (!selectors.isLicenseUpdating(state)) {
    dispatch(updateLicenseBegin());
    if (brandSelectors.getBrandValue(state, "Library.asyncLicense", false)) {
      return asyncUpdateLicense(dispatch);
    } else {
      return JigsawAPI.User.updateLicense()
        .then(() => dispatch(licenseUpdated()))
        .catch(error => dispatch(licenseUpdateFailed(error)));
    }
  }
};

const redeemCodeRequest = code => ({
  type: types.REDEEM_CODE_REQUEST,
  code
});

const redeemCodeSuccess = (code, books) => ({
  type: types.REDEEM_CODE_SUCCESS,
  code
});

const redeemCodeFailure = (error, code) => ({
  type: types.REDEEM_CODE_FAILURE,
  error,
  code
});

export const redeemCode = code => async (dispatch, getState) => {
  dispatch(redeemCodeRequest(code));
  return JigsawAPI.User.redeemCode(code)
    .then(async response => {
      const forceUpdate = true;
      response.code = 200;
      dispatch(redeemCodeSuccess(code, response.books));
      await dispatch(updateLicense());
      await dispatch(bridgeActions.fetchSession(forceUpdate));
      return response;
    })
    .catch(err => {
      dispatch(redeemCodeFailure(err, code));
      return err;
    });
};

// export const loadBookList = options => async (dispatch, getState) => {
//   dispatch(getBookListBegin());
//   let options = { order: "recent", offset: 0, perPage: 25, eager: true };
//   let response = await JigsawAPI.getBookList(options);
//   while (response.books.length > 0) {
//     dispatch(getBookListIntermediateResponse(response));
//     options.offset = options.offset + response.books.length;
//     options.perPage = 1000;
//     response = await JigsawAPI.getBookList(options);
//   }
//   dispatch(getBookListFinish());
// };

// export const getBookInfo = isbns => async (dispatch, getState) => {
//   const loaded = getState().license.books.byIsbn;
//   const stats = isbns.reduce(
//     (acc, i) => {
//       return loaded[i]
//         ? { ...acc, loaded: [...acc.loaded, loaded[i]] }
//         : { ...acc, needed: [...acc.needed, i] };
//     },
//     { loaded: [], needed: [] }
//   );

//   dispatch(getBookInfoRequest(stats.needed));

//   const newlyLoaded =
//     stats.needed.length > 0 ? await JigsawAPI.getBookInfo(stats.needed) : [];

//   dispatch(getBookInfoSuccess(newlyLoaded.books));
// };
